/* ==========================================================================
   ADW SPORTS — motion triggers

   Three small behaviours, all IntersectionObserver or passive scroll. No
   library, no layout reads inside scroll handlers, nothing that blocks input.

     1. .adw-scrolled on the header once the page has moved
     2. .adw-in on section headings when they enter view (draws the brass rule)
     3. A sticky "Book a showroom visit" button between the hero and the footer

   Everything is skipped when the visitor asks for reduced motion, except the
   sticky button, which is navigation rather than decoration and simply
   appears without the slide.
   ========================================================================== */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. header state ------------------------------------------ */

  function initHeader() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;

    var ticking = false;

    function update() {
      header.classList.toggle('adw-scrolled', window.scrollY > 24);
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    update();
  }

  /* ---------- 2. heading rules ----------------------------------------- */

  var HEADING_SELECTOR = ['.section-header', '.title-wrapper-with-link', '.collection__title'].join(',');

  function initHeadings(root) {
    var targets = (root || document).querySelectorAll(HEADING_SELECTOR);
    if (!targets.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(targets, function (el) {
        el.classList.add('adw-in');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('adw-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.1 }
    );

    Array.prototype.forEach.call(targets, function (el) {
      observer.observe(el);
    });
  }

  /* ---------- 3. sticky showroom CTA ----------------------------------- */

  var CTA_LABEL = 'Book a showroom visit';
  var CTA_HREF = '/pages/contact';

  function ctaAllowed() {
    var path = window.location.pathname;
    return !(
      path.indexOf('/cart') === 0 ||
      path.indexOf('/checkouts') === 0 ||
      path.indexOf('/account') === 0 ||
      path.indexOf('/pages/contact') === 0 ||
      path.indexOf('/pages/request') === 0
    );
  }

  function initCta() {
    if (!ctaAllowed()) return;
    if (document.querySelector('.adw-cta')) return;

    var link = document.createElement('a');
    link.className = document.querySelector('[id^="MainProduct-"]') ? 'adw-cta adw-cta--product' : 'adw-cta';
    link.href = CTA_HREF;
    link.setAttribute('aria-label', CTA_LABEL);
    link.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      '<path d="M8 2v4M16 2v4M3 10h18"/>' +
      '<rect x="3" y="4" width="18" height="18" rx="1.5"/>' +
      '</svg><span>' +
      CTA_LABEL +
      '</span>';

    document.body.appendChild(link);

    var footer = document.querySelector('.footer') || document.querySelector('footer');
    var shown = false;
    var nearFooter = false;
    var ticking = false;

    function apply() {
      link.classList.toggle('is-visible', shown && !nearFooter);
    }

    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            nearFooter = entry.isIntersecting;
            apply();
          });
        },
        { rootMargin: '120px 0px 0px 0px' }
      ).observe(footer);
    }

    function update() {
      shown = window.scrollY > window.innerHeight * 0.7;
      apply();
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    update();
  }

  /* ---------- boot ------------------------------------------------------ */

  function boot() {
    initHeader();
    initHeadings();
    initCta();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initHeadings(event.target);
    });
  }
})();
